module.exports = __webpack_public_path__ + "static/footer-entrust-a0d0046cb8c7a49f28c551ca8e7f8571.png";